angular.
module("dx.webapp.roles", [
	"digiexam.invite",
	"digiexam.node",
	"digiexam.services",
	"dx.webapp.user",
	"UIStateManager",

	"dx.ui.components.dialog",
	"dx.ui.components.localize",
]);
